import { Pipe, PipeTransform } from '@angular/core';
import { AnyObject, ItemBodyRender, CardStructureConfig, ItemAttrListDataSet } from '@mri/types';

@Pipe({
  name: 'cardBodyRender'
})
export class CardBodyRenderPipe implements PipeTransform {

  transform(date: AnyObject, prop: ItemAttrListDataSet, structure: CardStructureConfig<AnyObject>): Array<ItemBodyRender> {
    return structure.body(prop);
  }

}
